import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock } from "react-icons/fa";
import api from "../api/axios";
import "./Login.css";
import { UserContext } from "../context/UserContext";
import { useTranslation } from "../context/LanguageContext";
import logo from "../assets/logo.png";

export default function Login() {
  const { login: contextLogin } = useContext(UserContext);
  const { t } = useTranslation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await api.post("/api/token/", { username, password });
      const accessToken = res.data.access;
      const refreshToken = res.data.refresh;

      localStorage.setItem("access_token", accessToken);
      localStorage.setItem("refresh_token", refreshToken);

      if (contextLogin) {
        await contextLogin(accessToken);
      }

      setError("");
      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      setError(t.loginError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-hero">
          <div className="login-logo-container">
            <img src={logo} alt="Ranch de Ngaoundaba" className="login-logo" />
          </div>
          <div className="hero-badge">{t.appName}</div>
          <h1>{t.welcome}</h1>
          <p className="hero-subtitle">
            {t.heroSubtitle}
          </p>
          <div className="hero-highlight">
            <span>{t.dashboardRealtime}</span>
            <span>-</span>
            <span>{t.alertTracking}</span>
            <span>-</span>
            <span>{t.detailedReports}</span>
          </div>
        </div>

        <div className="login-panel">
          <div className="login-header">
            <h2>{t.loginTitle}</h2>
            <p>{t.loginSubtitle}</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <label htmlFor="username">{t.username}</label>
            <div className="input-wrapper">
              <FaUser className="input-icon" aria-hidden />
              <input
                id="username"
                name="username"
                className="login-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                required
              />
            </div>

            <label htmlFor="password">{t.password}</label>
            <div className="input-wrapper">
              <FaLock className="input-icon" aria-hidden />
              <input
                id="password"
                name="password"
                type="password"
                className="login-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>

            {error && <p className="login-error">{error}</p>}

            <button className="login-button" disabled={loading}>
              {loading ? t.loggingIn : t.loginButton}
            </button>
          </form>

          <p className="login-footnote">
            {t.loginHelp}
          </p>
        </div>
      </div>
    </div>
  );
}